import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect } from '@socialive/common';
import { DEFAULT_FILTER_OPTION, FILTER_STORAGE_KEY } from '~/helpers/constants';
import { setCurrentAccountId } from '~/store/accountInfo';

export const effect = createListenerEffect(
  'accountInfo/resetRecordingFilters<Listener>',
  async (action, { getState, dispatch }) => {
    sessionStorage.setItem(FILTER_STORAGE_KEY.HOST, JSON.stringify(DEFAULT_FILTER_OPTION.HOST));
    sessionStorage.setItem(FILTER_STORAGE_KEY.CHANNEL, DEFAULT_FILTER_OPTION.CHANNEL);
    localStorage.setItem(FILTER_STORAGE_KEY.CHANNEL, DEFAULT_FILTER_OPTION.CHANNEL);
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  actionCreator: setCurrentAccountId,
  effect,
});

export default middleware;
